import Yup from '@fourthwall/utils/dist/yup'

export const validationSchema = Yup.object().shape({
  email: Yup.string().email().required(),
})

export const ROLES = [
  {
    checkedValue: 'VIEWER',
    label: 'Viewer',
    suggestion:
      'Viewers can see orders, product details and analytics but cannot make any changes.',
  },
  {
    checkedValue: 'MANAGER',
    label: 'Manager',
    suggestion:
      'Managers have full admin rights but cannot change payout details or invite new team members.',
  },
  {
    checkedValue: 'OWNER',
    label: 'Owner',
    suggestion: 'Owners have full admin privileges.',
  },
]
